import { render } from "./TrackerCreateConfirmation.vue?vue&type=template&id=2ebca883"
import script from "./TrackerCreateConfirmation.vue?vue&type=script&lang=js"
export * from "./TrackerCreateConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script